/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
import React, { useState, useEffect } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import Snackbar from "@mui/material/Snackbar";

// Billing page components
import AddPolice from "layouts/police/components/AddPolice";

// Data
import FetchPoliceData from "layouts/police/data/policeTableData";

function Police() {
  const [open, setOpen] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [formData, setFormData] = useState({});
  const [isEdit, setIsEdit] = useState(false);

  const addPolice = () => {
    console.log("Add police");
    //open dialog box where add police form is displayed
    setOpen(true);
    setFormData({});
    setIsEdit(false);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSuccess = () => {
    setSnackbarOpen(true);
    setRefresh(true);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleEditData = (data) => {
    setFormData(data);
    setOpen(true);
    setIsEdit(true);
  };

  return (
    <DashboardLayout>
      <DashboardNavbar absolute isMini />
      <MDBox pt={8} px={2} display="flex" justifyContent="space-between" alignItems="center">
        <MDTypography variant="h6" fontWeight="medium"></MDTypography>
        <MDButton variant="gradient" color="dark" onClick={addPolice}>
          <Icon sx={{ fontWeight: "bold" }}>add</Icon>
          &nbsp;add new police stations
        </MDButton>
      </MDBox>
      <MDBox pt={8} pb={3}>
        <Grid container spacing={12}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Police stations
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <FetchPoliceData onRefresh={refresh} editData={handleEditData} />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
      <Dialog open={open} onClose={handleClose} maxWidth="xl" fullWidth>
        <Grid container justifyContent="space-between" alignItems="center">
          <DialogTitle>{isEdit ? "Edit Police" : "Add Police"}</DialogTitle>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Close
            </Button>
          </DialogActions>
        </Grid>
        <DialogContent>
          <AddPolice onClose={handleClose} onSuccess={handleSuccess} editFormData={formData} />
        </DialogContent>
      </Dialog>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleSnackbarClose} severity="success" sx={{ width: "100%" }}>
          Police station created successfully!
        </Alert>
      </Snackbar>
    </DashboardLayout>
  );
}

export default Police;
